<div class="loading fade-in">
	@if (loading) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}
</div>
